'use strict';
import React, { Component } from 'react'

export default class fraudTypes extends Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="container">
        <div className="row text-justify">
          {
            this.props.locale == "es" ?
            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-12">
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Tipos de fraude.
                  </p>
                  <p>
                    A medida que la tecnología avanza, los estafadores han 
                    encontrado mecanismos que facilitan la perpetración de 
                    actividades fraudulentas, desde publicaciones falsas en 
                    redes sociales hasta contraseñas para acceder a cuentas 
                    financieras, los estafadores han encontrado innumerables 
                    maneras de obtener el dinero de otras personas.
                  </p>
                  <p>
                    Estas estafas generalmente comienzan con una llamada, 
                    mensaje de texto o correo electrónico. Las estafas pueden 
                    variar, pero todas funcionan de la misma manera: un 
                    estafador se convierte en alguien en quien la persona 
                    confía para convencerlos de enviar dinero o compartir 
                    información personal.
                  </p>
                  <p>
                    Los estafadores pueden pedir que se transfieran dinero 
                    bien sea a una cuenta bancaria o simplemente efectivo, 
                    utilizando una empresa de transferencia de dinero como 
                    Barri, poner dinero en una tarjeta de regalo o enviar 
                    una criptomoneda porque saben que puede ser difícil 
                    revertir este tipo de pago.
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-3">
                  <ul>
                    <li><a href="#advancedFee">Estafa en pagos por adelantado</a></li>
                    <li><a href="#antivirus">Estafa en compra de antivirus</a></li>
                    <li><a href="#charity">Estafa benéfica</a></li>
                    <li><a href="#emergency">Estafa de emergencia</a></li>
                    <li><a href="#employment">Estafa laboral</a></li>
                    <li><a href="#extortion">Extorsión</a></li>
                    <li><a href="#fakeCheck">Estafa de cheques falsos</a></li>
                  </ul>
                </div>
                <div className="col-md-3">
                  <ul>
                    <li><a href="#grandparentScam">Estafa de abuelos</a></li>
                    <li>Robo de identidad</li>
                    <li><a href="#immigrationScam">Estafa de inmigración</a></li>
                    <li>Estafa telefónica contra inmigrantes</li>
                    <li><a href="#internetPurchase">Estafa de compra por Internet</a></li>
                    <li><a href="#loteryScam">Estafa lotería / premio</a></li>
                    <li><a href="#moneyFlippingScam">Estafa: Mulas de dinero</a></li>
                  </ul>
                </div>
                <div className="col-md-3">
                  <ul>
                    <li><a href="#military">Militar</a></li>
                    <li>Estafa misteriosa de compras</li>
                    <li><a href="#overpaymentScam">Estafa de pago excesivo</a></li>
                    <li><a href="#phishing">Phishing</a></li>
                    <li><a href="#relationship">Estafa de relaciones</a></li>
                    <li><a href="#rentalScam">Estafa de la propiedad de alquiler</a></li>
                    <li><a href="#socialNetworkScam">Estafa en redes sociales</a></li>
                  </ul>
                </div>
                <div className="col-md-3">
                  <ul>
                    <li><a href="#sms">Mensajes de Texto: SMS</a></li>
                    <li><a href="#taxScam">Estafa fiscal</a></li>
                    <li><a href="#telemarketing">Telemarketing</a></li>
                  </ul>
                </div>
              </div>
              <hr className="small-blue" />
              <div id="advancedFee" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    1.- Estafa de pago por anticipado
                  </p>
                  <p>
                    Una estafa por honorarios anticipados es una forma de fraude y 
                    uno de los tipos más comunes de trucos de confianza. La estafa 
                    normalmente implica prometer a la víctima una parte significativa 
                    de una gran suma de dinero, a cambio de un pequeño pago inicial, 
                    que el estafador afirma que se utilizará para obtener la gran suma.
                  </p>
                  <p>
                    A la víctima se le pide que pague cuotas iniciales por servicios 
                    financieros que nunca se proporcionan. Las víctimas a menudo envían 
                    una sucesión de transacciones para el pago de varias tarifas iniciales. 
                    Los métodos comunes podrían incluir: tarjeta de crédito, 
                    suscripciones, préstamos, herencia o inversión.
                  </p>
                  <p>Asociado con: <br/><a href="#taxScam">Estafa fiscal</a>,<a href="#telemarketing"> Telemarketing</a>, <a href="#immigrationScam">Estafa de inmigración</a>, 
                  <a href="#charity">estafa de caridad</a>, <a href="#socialNetworkScam">estafa en redes sociales</a>, <a href="#fakeCheck">estafa cheque falso</a>, 
                  <a href="#grandparentScam">estafa de abuelos</a>
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" style={{height:"200px"}} src="img/estafa_pagoanticipado_es.png" alt="alert" />
                </div>
              </div>
              <div id="antivirus" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    2.- Estafa en compra de antivirus
                  </p>
                  <p>
                    La víctima es contactada por alguien que afirma que es de una conocida 
                    compañía de computadoras o software y se ha detectado un virus en el 
                    ordenador de la víctima. Le recomienda a la víctima que el virus se 
                    puede eliminar y le vende un programa para protegerlo y le solicita 
                    una pequeña tarifa con un pago con tarjeta de crédito o una transferencia 
                    de dinero. En realidad, no había ningún virus su computadora y la víctima 
                    acaba de perder el dinero que envio para la compra del antivirus.
                  </p>
                  <p>Asociado con: <br/><a href="#advancedFee">Tarifa avanzada / estafa de prepago</a>, robo de identidad, 
                    <a href="#phishing">phishing</a>
                  </p>
                  <p>
                    El artículo se refiere: <br/><a href="https://www.consumidor.ftc.gov/blog/2020/04/la-ftc-envia-mas-advertencias-vendedores-de-tratamientos-enganosos-para-el-coronavirus" target="_blank">
                    https://www.consumidor.ftc.gov/blog/2020/04/la-ftc-envia-mas-advertencias-vendedores-de-tratamientos-enganosos-para-el-coronavirus 
                    </a>
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" style={{height:"150px"}} src="img/estafa_antivirus_es.png" alt="alert" />
                </div>
              </div>
              <div id="charity" className="row" style={{marginTop:45}}>
                <div className="col-md-12">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    3.- Estafa benéfica
                  </p>
                  <p>
                    El fraude de caridad es el acto de usar el engaño para obtener 
                    dinero de personas que creen que están haciendo donaciones a 
                    organizaciones benéficas. A menudo, una persona o un grupo de 
                    personas se declaran como una organización benéfica o parte de 
                    una organización benéfica y pedirán contribuciones a la personas.
                  </p>
                  <p>
                    La víctima es a menudo contactada por correo electrónico, correo 
                    o teléfono por alguien que pide que una donación sea enviada por 
                    transferencia de dinero a una persona para ayudar a las víctimas 
                    de un evento actual reciente, como un desastre o una emergencia 
                    (como una inundación, ciclón o terremoto). Las organizaciones 
                    benéficas legítimas nunca pedirán que se envíen donaciones a una 
                    persona a través de un servicio de transferencia de dinero.
                  </p>
                  <p>Asociado con: <br/><a href="#advancedFee">Tarifa avanzada / Estafa de prepago</a>, 
                    <a href="#phishing">Phishing</a>, <a href="#sms">SMS / Smishing</a>
                  </p>
                  <p>
                    Artículo relacionado: <br/><a href="https://www.consumidor.ftc.gov/blog/2018/07/estafadores-crean-falsas-emergencias-para-conseguir-tu-dinero%C2%A0" target="_blank">
                    https://www.consumidor.ftc.gov/blog/2018/07/estafadores-crean-falsas-emergencias-para-conseguir-tu-dinero%C2%A0</a>
                  </p>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <img className="img-responsive center-block" style={{height:"150px"}} src="img/estafa1_charity_es.png" alt="alert" />
                  </div>
                  <div className="col-md-8">
                    <img className="img-responsive center-block" style={{height:"150px"}} src="img/estafa2_charity_es.png" alt="alert" />
                  </div>
                </div>
              </div>
              <div id="emergency" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    4.- Estafa de emergencia
                  </p>
                  <p>
                    A la víctima se le hace creer que están enviando fondos para ayudar 
                    a un amigo o ser querido en necesidad urgente. La víctima envía el 
                    dinero con urgencia mientras se explota la preocupación natural de 
                    la víctima por un ser querido.
                  </p>
                  <p>Asociado con: <br/> <a href="#grandparentScam">Estafa de abuelos</a>, 
                    <a href="#advancedFee">tarifa avanzada / estafa de prepago</a>
                  </p>
                  <p>
                    El artículo se refiere:<br/><a target="_blank" href="https://www.consumidor.ftc.gov/blog/2018/07/estafadores-crean-falsas-emergencias-para-conseguir-tu-dinero">
                    https://www.consumidor.ftc.gov/blog/2018/07/estafadores-crean-falsas-emergencias-para-conseguir-tu-dinero</a>
                  </p>
                </div>
                <div className="col-md-m3">
                  <img className="img-responsive center-block" style={{height:"150px"}} src="img/estafa_emergency_es.png" alt="alert" />
                </div>
              </div>
              <div id="employment" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    5.- Estafa laboral
                  </p>
                  <p>
                    La víctima responde a un puesto de trabajo y es contratada para el 
                    trabajo ficticio y envía un cheque falso para gastos relacionados 
                    con el trabajo. El monto del cheque excede los gastos de la víctima 
                    y la víctima envía fondos restantes de vuelta usando una transferencia 
                    de dinero. El cheque rebota y la víctima es responsable de la cantidad 
                    total.
                  </p>
                  <p>
                    Los estafadores publican anuncios prometiendo acceso a "exclusivos" 
                    listados de vacantes de empleo, puestos de trabajo "garantizados”, y 
                    otras cosas parecidas — todo a cambio del pago de un cargo adelantado. 
                    Pero hay muchos buscadores de empleo que pagaron esos cargos y que 
                    sólo recibieron listados desactualizados para puestos de trabajo que 
                    ya habían sido cubiertos, listados falsos, o nada de nada. Aprenda a 
                    detectar una estafa para cuando salga a buscar trabajo.
                  </p>
                </div>
                <div className="col-md-m3">
                  <img className="img-responsive center-block" style={{height:"200px"}} src="img/estafa_laboral_es.png" alt="alert" />
                </div>
              </div>
              <div id="extortion" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    6.- Extorsión
                  </p>
                  <p>
                    Amenazas a la vida, arresto u otras demandas de los estafadores 
                    para obtener ilegalmente dinero, bienes o servicios de una víctima 
                    a través de la coerción que supuestamente deben y amenazan si no 
                    cooperan.
                  </p>
                  <p>Hacen llamadas donde tratan de engañarte, te amenazan hasta el 
                    punto de asustarte para que les des tu dinero.</p>
                  <p>
                    La estafa del teléfono de extorsión de los padres comienza con 
                    alguien que le envía una foto de su propio hijo por mensaje de 
                    texto: la foto podría haber sido tomada de Internet, por ejemplo, 
                    desde su cuenta pública de redes sociales. A veces estos estafadores 
                    también envían fotos de miedo, como imágenes de cuerpos descuartizados. 
                    En cualquier caso, los mensajes vienen junto con la amenaza de un 
                    estafador que dice que sabe dónde vives y que matará a tu familia 
                    si no le pagas. Si recibes una llamada como esta, antes de hacer 
                    cualquier otra cosa, denúnciala a tu departamento de policía local 
                    inmediatamente.
                  </p>
                  <p>Asociado con: <br/><a href="#advancedFee">Tarifa avanzada / Estafa de prepago</a>, 
                    <a href="#relationship">Estafa de relación</a>, 
                    <a href="#immigrationScam">Estafa de inmigración</a>, 
                    <a href="#taxScam">Estafa fiscal</a>, 
                    <a href="#emergency">Estafa de emergencia</a>, 
                    <a href="#antivirus">Estafa antivirus</a>, 
                    <a href="#phishing">Phishing</a>
                  </p>
                  <p>
                    Artículo Relacionado:<br/><a target="_blank" href="https://www.consumidor.ftc.gov/blog/2020/10/estafas-telefonicas-amenazantes-contra-padres-e-inmigrantes">
                      https://www.consumidor.ftc.gov/blog/2020/10/estafas-telefonicas-amenazantes-contra-padres-e-inmigrantes
                    </a>
                  </p>
                </div>
                <div className="col-md-m3">
                  <img className="img-responsive center-block" style={{height:"200px"}} src="img/extorcion_es.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="fakeCheck" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    7.- Estafa de cheques falsos
                  </p>
                  <p>
                    A las víctimas a menudo se les envía un cheque como parte de una estafa 
                    y se les dice que depositen el cheque y utilicen los fondos para gastos 
                    de empleo, compras por Internet, etc. El cheque es falso (falsificado), 
                    y la víctima queda responsable de cualquier dinero utilizado del cheque. 
                    Recuerde, los fondos de un cheque depositado en una cuenta no deben 
                    utilizarse hasta que el cheque sea efectivo por el banco, lo que puede 
                    tardar semanas.
                  </p>
                  <p>Asociado con: <br/>
                    <a href="#advancedFee">Cuota avanzada / estafa de prepago</a>, estafa misteriosa 
                    de compras, <a href="#employment">estafa de empleo</a>, 
                    <a href="#overpaymentScam">estafa de pago excesivo</a>, 
                    <a href="#internetPurchase">estafa de compra de Internet</a>, 
                    <a href="#loteryScam">estafa lotería / premio</a>, 
                    <a href="#rentalScam">estafa de la propiedad de alquiler</a>
                  </p>
                </div>
                <div id="grandparentScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    8.- Estafa del abuelo
                  </p>
                  <p>
                    Esta estafa es una variación de la estafa de emergencia. La víctima es 
                    contactada por un individuo que finge ser un nieto en apuros, o una persona 
                    de autoridad como un profesional médico, un oficial de la ley o un abogado.
                  </p>
                  <p>
                    El estafador describe una situación urgente o emergencia (fianza, gastos 
                    médicos, fondos de viaje de emergencia) que involucra al nieto que 
                    requiere una transferencia de dinero inmediata. 
                  </p>
                  <p>
                    No se ha producido ninguna emergencia y la víctima que envió dinero 
                    para ayudar a su nieto ha perdido su dinero.
                  </p>
                  <p>Asociado con: <br/> 
                    <a href="#advancedFee">Tarifa avanzada / Estafa por prepago</a>, 
                    <a href="#emergency">estafa de emergencia</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="immigrationScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    9.- Estafa de inmigración
                  </p>
                  <p>
                    Estafa telefónica contra inmigrantes, comienza <a target="_blank"
                    href="https://www.consumer.ftc.gov/media/video-0117-family-emergency-imposter-scams">
                    <strong>como una llamada de un impostor</strong></a> haciéndose pasar por alguien del Servicio de Inmigración y 
                    Control de Aduanas de los Estados Unidos (ICE, por sus inglés). A menudo, 
                    estos estafadores dicen que están revocando su estatus migratorio y que 
                    la policía está en camino de arrestarlo o deportarlo, a menos que les 
                    pague de inmediato.
                  </p>
                  <p>Asociado con: <br/> 
                    <a href="#advancedFee">Tarifa avanzada / estafa de prepago</a>, 
                    <a href="#overpaymentScam">estafa de pago excesivo</a>, <a href="#emergency">estafa de emergencia</a>
                  </p>
                </div>
                <div id="internetPurchase" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    10.- Estafa de compra por Internet
                  </p>
                  <p>
                    Las víctimas podrían ser el comprador o un vendedor de artículos 
                    (por ejemplo: mascotas, carros o servicios anunciados en línea a 
                    través de Craigslist, eBay, Alibaba, etc). Estafadores que fingen 
                    ser vendedores legítimos en línea, ya sea con un sitio web falso o 
                    un anuncio falso en un sitio genuino que anuncia un artículo a un 
                    precio bajo. Le piden que pague utilizando una orden de dinero, 
                    tarjeta de dinero precargada o transferencia de dinero, después de 
                    que se envía el dinero, la víctima nunca recibe la mercancía o 
                    servicio. Los estafadores también pretenden ser compradores legítimos 
                    enviando más que el precio de venta, y le pide al vendedor que les 
                    devuelva la diferencia a través de una transferencia de dinero.
                  </p>
                  <p>Asociado con: <br/>
                    <a href="#overpaymentScam">Estafa de pago excesivo</a>, <a href="#rentalScam">estafa de propiedad de alquiler</a>, 
                    <a href="#fakeCheck">estafa cheque falso</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="loteryScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    11.- Estafa de lotería / premio
                  </p>
                  <p>
                    A la víctima se le dice que han ganado una lotería, premio o sorteo 
                    y que el dinero debe ser enviado para cubrir los impuestos o cargos 
                    sobre las ganancias. La víctima puede recibir un cheque por parte 
                    de las ganancias y una vez depositado el cheque y enviado dinero, 
                    el cheque rebota.
                  </p>
                  <p>Asociado con: <br/>
                    <a href="advancedFee">Tarifa avanzada / estafa de prepago</a>, <a href="#fakeCheck">estafa cheque falso</a>
                  </p>
                </div>
                <div id="moneyFlippingScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    12.- Estafa de giro de dinero
                  </p>
                  <p>
                    Las redes sociales se utilizan para atraer a nuevas víctimas a 
                    una vieja estafa de hacerse rico-rápido donde los usuarios están 
                    anunciando maneras de convertir $100 en $ 1,000 por "voltear 
                    dinero". El discurso sugiere que los inversores pueden aprovechar 
                    las ventajas en el sistema monetario y obtener  efectivo adicional;  
                    convertir unos pocos cientos de dólares en miles. Una vez que los 
                    estafadores tienen acceso al dinero en efectivo, a menudo bloquean 
                    a la víctima quien ya no puede ponerse en contacto con ellos a 
                    través de las redes sociales o el número de teléfono.
                  </p>
                  <p>Asociado con: <br/> 
                    <a href="#socialNetworkScam">Estafa en redes sociales</a>, 
                    <a href="#advancedFee">tarifa avanzada / estafa por prepago</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="military" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    13.- Militares
                  </p>
                  <p>
                    Los militares son un objetivo atractivo para los estafadores 
                    por varias razones. Están abusando de la admiración extendida 
                    por los militares y haciéndose pasar por hombres y mujeres de 
                    servicio con el fin de engañar a la gente para que les envíe 
                    dinero.
                  </p>
                  <p>Asociado con: <br/> 
                    <a href="#relationship">Estafa de relación</a>, <a href="#advancedFee">cuota avanzada / estafa de prepago</a>, 
                    <a href="#emergency">estafa de emergencia</a>, <a href="#charity">estafa de caridad</a>, 
                    <a href="#employment">estafa de empleo</a>
                  </p>
                </div>
                <div id="overpaymentScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    14.- Estafa donde le solicitan evaluar un servicio
                  </p>
                  <p>
                    El estafador se pone en contacto con la víctima a través de un 
                    sitio web de empleo, o la víctima responde a un anuncio sobre 
                    una oportunidad de empleo para evaluar un servicio de transferencia 
                    de dinero. El estafador a menudo envía a la víctima un cheque para 
                    depositar e instruye a la víctima a enviar una transferencia de 
                    dinero, manteniendo una parte del cheque para su pago. La víctima 
                    envía el dinero, el estafador lo recoge, y cuando el cheque rebota 
                    la víctima se queda responsable de la cantidad total.
                  </p>
                  <p>Asociado con: <br/> 
                    <a href="#fakeCheck">Estafa cheque falso</a>, <a href="#employment">estafa de empleo</a>, 
                    <a href="#advancedFee">tarifa avanzada / estafa de prepago</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="phishing" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    15.- Phishing
                  </p>
                  <p>
                    Comunicación haciéndose pasar por una entidad de confianza, 
                    como un banco o una empresa hipotecaria, con la intención de 
                    engañar a la víctima para que proporcione información personal 
                    o contraseñas. Un phishing es un intento fraudulento, 
                    generalmente hecho a través de correo electrónico (aunque 
                    también se puede hacer a través del teléfono o el texto), para 
                    robar su información personal o propagar código malicioso o 
                    software en su ordenador.
                  </p>
                  <p>Asociado con: <br/> 
                    <a href="#relationship">Estafa de relación</a>, <a href="#extortion">Extorsión</a>, 
                    <a href="#emergency">Estafa de emergencia</a>, <a href="#socialNetworkScam">Estafa en redes sociales</a>, 
                    <a href="#sms">SMS /Smishing</a>
                  </p>
                </div>
                <div id="relationship" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    16.- Estafa Romantica
                  </p>
                  <p>
                    La víctima es llevada a creer que tienen una relación 
                    personal con alguien que conocieron en internet a través 
                    de las redes sociales, en un foro en línea o en un sitio 
                    web de citas. La víctima es a menudo emocionalmente 
                    influenciada para que ayude económicamente al supuesto 
                    amigo(a), novio(a).
                  </p>
                  <p>Asociado con: <br/> 
                    <a href="#socialNetworkScam">Estafa en redes sociales</a>, <a href="#military">militar</a>, 
                    <a href="#emergency">estafa de emergencia</a>, <a href="#extortion">extorsión</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="rentalScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    17.- Estafa de alquiler
                  </p>
                  <p>
                    La víctima envía dinero para el depósito en una propiedad de 
                    alquiler y nunca recibe acceso a la propiedad de alquiler o 
                    la víctima también puede ser el propietario de la propiedad 
                    que se envía un cheque del arrendatario y se le pide que 
                    envíe una parte del cheque de vuelta utilizando una 
                    transferencia de dinero y el cheque no tiene fondos.
                  </p>
                  <p>Asociado con: <br/>
                    <a href="#internetPurchase">Estafa de compra de Internet</a>, <a href="#fakeCheck">estafa cheque falso</a>, 
                    <a href="#overpaymentScam">estafa de pago excesivo</a>
                  </p>
                </div>
                <div id="socialNetworkScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    18.- Estafa en redes sociales
                  </p>
                  <p>
                    Si un ciber delincuente que obtiene acceso a sus cuentas de 
                    redes sociales, también obtienen acceso a sus amigos y familiares 
                    cercanos. Los criminales y estafadores pueden aprovechar la 
                    cantidad de información personal que las personas comparten 
                    en línea, y luego utilizar esta información para extorsionar 
                    y solicitar de dinero, sea confundiendo a su red de amigos 
                    o amenazando con compartir su información.
                  </p>
                  <p>Asociado con: <br/>
                    <a href="#phishing">Phishing</a>, <a href="#emergency">Estafa de emergencia</a>, 
                    <a href="#grandparentScam">Estafa de abuelos</a>, <a href="#military">Militar</a>, 
                    <a href="#sms">SMS /Smishing</a>, <a href="#advancedFee">Tarifa avanzada / Estafa de prepago</a>, 
                    <a href="#relationship">Estafa de relación</a>, Robo de identidad
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="sms" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    19.- Mensajes de Texto: SMS/Smishing
                  </p>
                  <p>
                    Tenga cuidado con los textos que despiertan urgencia, pidiéndole 
                    que haga clic en un enlace, llevándose a un sitio comprometido, 
                    o consiga divulgar involuntariamente alguna información personal 
                    que podría ser utilizada en su contra.
                  </p>
                  <p>Asociado con: <br/>
                    Robo de identidad, <a href="#phishing">phishing</a>, <a href="#antivirus">estafa antivirus</a>, 
                    <a href="#advancedFee">cuota avanzada / estafa de prepago</a>, 
                    <a href="#loteryScam">lotería / estafa premio</a>
                  </p>
                </div>
                <div id="taxScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    20.- Estafa fiscal
                  </p>
                  <p>
                    La víctima es contactada por alguien que dice ser de una agencia 
                    gubernamental diciendo que debe dinero por impuestos, y debe ser 
                    pagado inmediatamente para evitar el arresto, deportación o 
                    suspensión de la licencia de conducir / pasaporte. Se solicita a 
                    la víctima a enviar una transferencia de dinero o comprar una 
                    tarjeta de débito precargada para pagar los impuestos. Las agencias 
                    gubernamentales nunca exigirán el pago inmediato o llamarán a 
                    impuestos sin antes haber enviado una carta por correo.
                  </p>
                  <p>Asociado con: <br/>
                    <a href="#advancedFee">Tarifa avanzada / Estafa de prepago</a>, <a href="#overpaymentScam">estafa de pago excesivo</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="telemarketing" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    21.- Telemarketing
                  </p>
                  <p>
                    El telemarketing cubre ampliamente casi cualquier transacción 
                    comercial que implique el uso de un teléfono para colocar o 
                    recibir llamadas entre un consumidor y un telemercado o vendedor 
                    para la transferencia de fondos, tales como transferencias de 
                    dinero en efectivo o fondos cargados en una tarjeta prepagada, 
                    como pago por bienes o servicios ofrecidos o vendidos a través 
                    del telemarketing, a menudo relacionados con una promoción para 
                    unas vacaciones "gratuitas" o con grandes descuentos , estafas 
                    de premios o sorteos, o la venta de revistas de "ganga".
                  </p>
                  <p>Asociado con: <br/>
                    <a href="#charity">Estafa de caridad</a>, <a href="#advancedFee">cuota avanzada / estafa de prepago</a>, 
                    <a href="#rentalScam">estafa de la propiedad de alquiler</a>, <a href="#loteryScam">estafa lotería / premio</a>, 
                    <a href="#internetPurchase">estafa de compra de Internet</a>, robo de identidad.
                  </p>
                </div>
              </div>

            </div> 
            
            :

            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-12">
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Types of Fraud.
                  </p>
                  <p>
                    As technology advances scammers have found mechanisms that 
                    make they easier for perpetrate fraudulent activity, from 
                    fake social media posts to phishing passwords for financial 
                    accounts, scammers have found countless ways to keep other 
                    people's money.
                  </p>
                  <p>
                    These scams usually start with a call, text message or email. 
                    Scams may vary, but they all work the same way: a scammer 
                    becomes someone the person trusts to convince them to send 
                    money or share personal information.
                  </p>
                  <p>
                    Scammers can ask to have money transferred from their bank 
                    account, or transferred money using a money transfer company 
                    such as Barri, put money on a gift card, or send a 
                    cryptocurrency because they know it can be difficult to 
                    reverse these types of payment.
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-4">
                  <ul>
                    <li><a href="#advancedFee">Advanced fee / Prepayment scam</a></li>
                    <li><a href="#antivirus">Anti-Virus scam</a></li>
                    <li><a href="#charity">Charity scam</a></li>
                    <li><a href="#emergency">Emergency scam</a></li>
                    <li><a href="#employment">Employment scam</a></li>
                    <li><a href="#extortion">Extortion</a></li>
                    <li><a href="#fakeCheck">Fake check scam</a></li>
                  </ul>
                </div>
                <div className="col-md-4">
                  <ul>
                    <li><a href="#grandparentScam">Grandparent scam</a></li>
                    <li>Identity theft</li>
                    <li><a href="#immigrationScam">Inmigration scam</a></li>
                    <li><a href="#internetPurchase">Internet purcharse scam</a></li>
                    <li><a href="#loteryScam">Lottery / Prize scam</a></li>
                    <li><a href="#moneyFlippingScam">Money-Flipping scam</a></li>
                    <li><a href="#military">Military</a></li>
                    <li>Mystery shopping scam</li>
                  </ul>
                </div>
                <div className="col-md-4">
                  <ul>
                    <li><a href="#overpaymentScam">Overpayment scam</a></li>
                    <li><a href="#phishing">Phishing</a></li>
                    <li><a href="#relationship">Relationship scam</a></li>
                    <li><a href="#rentalScam">Rental property scam</a></li>
                    <li><a href="#socialNetworkScam">Social networking scam</a></li>
                    <li><a href="#sms">SMS / Smishing</a></li>
                    <li><a href="#taxScam">Tax scam</a></li>
                    <li><a href="#telemarketing">Telemarketing</a></li>
                  </ul>
                </div>
              </div>
              <hr className="small-blue" />
              <div id="advancedFee" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    1.- Advanced Fee / Prepayment scam
                  </p>
                  <p>
                    An advance-fee scam is a form of fraud and one of the most common 
                    types of confidence tricks. The scam typically involves promising 
                    the victim a significant share of a large sum of money, in return 
                    for a small up-front payment, which the fraudster claims will be 
                    used to obtain the large sum.
                  </p>
                  <p>
                    Victim is asked to pay upfront fees for financial services which 
                    are never provided. Victims often send a succession of transactions 
                    for payment of various upfront fees. Common methods could include: 
                    credit card, grants, loans, inheritance, or investment.
                  </p>
                  <p>Associated with: <br/><a href="#taxScam">Tax scam</a>, <a href="#telemarketing">Telemarketing</a>, 
                    <a href="#immigrationScam">Immigration scam</a>, <a href="#charity">Charity scam</a>, <a href="#socialNetworkScam">Social Networking scam</a>, 
                     <a href="#fakeCheck">Fake Check scam</a>, <a href="#grandparentScam">Grandparent scam</a>
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" style={{height:"200px"}} src="img/estafa_pagoanticipado_en.png" alt="alert" />
                </div>
              </div>
              <div id="antivirus" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    2.- Anti-Virus scam
                  </p>
                  <p>
                    Victim is contacted by someone claiming they are from a well-known 
                    computer or software company and a virus has been detected on the 
                    victim’s computer. The victim is advised that the virus can be 
                    removed and the computer protected for a small fee with a payment 
                    by either credit card or a money transfer. In reality, there was 
                    no virus on the computer and the victim has just lost the money 
                    they sent for the protection.
                  </p>
                  <p>Associated with: <br/><a href="#advancedFee">Advanced Fee / Prepayment scam</a>, Identity Theft, 
                      <a href="#phishing">Phishing</a>
                  </p>
                  <p>
                    Article relate: <br/><a href="https://www.consumer.ftc.gov/articles/how-spot-avoid-and-report-tech-support-scams" target="_blank">
                    https://www.consumer.ftc.gov/articles/how-spot-avoid-and-report-tech-support-scams
                    </a>
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" style={{height:"200px"}} src="img/estafa_antivirus_en.png" alt="alert" />
                </div>
              </div>
              <div id="charity" className="row" style={{marginTop:45}}>
                <div className="col-md-12">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    3.- Charity scam
                  </p>
                  <p>
                    Charity fraud is the act of using deception to get money from 
                    people who believe they are making donations to charities. 
                    Often a person or a group of people will make material representations 
                    that they are a charity or part of a charity and ask prospective 
                    donors for contributions to the non-existent charity.
                  </p>
                  <p>
                    The victim is often contacted by email, mail or phone by someone 
                    asking for a donation to be sent by money transfer to an individual 
                    to help victims of a recent current event, such as a disaster or 
                    emergency (such as a flood, cyclone, or earthquake). Legitimate 
                    charity organizations will never ask for donations to be sent to 
                    an individual through a money transfer service.
                  </p>
                  <p>Associated with: <br/> <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, 
                    <a href="#phishing">Phishing</a>, <a href="#sms">SMS/ Smishing</a>
                  </p>
                  <p>
                    Article Relate: <br/><a href="https://www.aarp.org/money/scams-fraud/info-2019/charity.html" target="_blank">
                    https://www.aarp.org/money/scams-fraud/info-2019/charity.html</a>
                  </p>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <img className="img-responsive center-block" style={{height:"150px"}} src="img/estafa1_charity_en.png" alt="alert" />
                  </div>
                  
                </div>
              </div>
              <div id="emergency" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    4.- Emergency scam
                  </p>
                  <p>
                    Victim is led to believe that they are sending funds to 
                    assist a friend or loved one in urgent need. Victim sends 
                    the money with urgency as the victim’s natural concern for 
                    a loved one is exploited.
                  </p>
                  <p>Associated with: <br/><a href="#grandparentScam">Grandparent scam</a>, 
                      <a href="#advancedFee">Advanced Fee / Prepayment scam</a>
                  </p>
                  <p>
                    Article relate: <br/>
                    <ol>
                      <li>
                        <a target="_blank" href="https://www.consumidor.ftc.gov/blog/2018/07/estafadores-crean-falsas-emergencias-para-conseguir-tu-dinero">
                          https://www.consumidor.ftc.gov/blog/2018/07/estafadores-crean-falsas-emergencias-para-conseguir-tu-dinero</a>
                      </li>
                      <li><a target="_blank" href="https://www1.nyc.gov/site/nypd/services/law-enforcement/crime-prevention-and-safety-tips.page">
                        https://www1.nyc.gov/site/nypd/services/law-enforcement/crime-prevention-and-safety-tips.page
                        </a></li>
                    </ol>
                  </p>
                </div>
                <div className="col-md-m3">
                  <img className="img-responsive center-block" style={{height:"150px"}} src="img/estafa_emergency_es.png" alt="alert" />
                </div>
              </div>
              <div id="employment" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    5.- Employment scam
                  </p>
                  <p>
                    Victim responds to a job posting and is hired for the fictitious 
                    job and sent a fake check for job related expenses. Check amount 
                    exceeds the victim’s expenses and victim sends remaining funds 
                    back using a money transfer. The check bounces and the victim is 
                    responsible for the full amount.
                  </p>
                  <p>Associated with: <br/> Mystery Shopping scam,
                      <a target="_blank" href="#fakeCheck"> Fake Check scam</a>
                  </p>
                  <p>
                    Article Relate: <br/><a target="_blank" href="https://www.consumer.ftc.gov/articles/job-scams">
                    https://www.consumer.ftc.gov/articles/job-scams
                    </a>
                  </p>
                </div>
                <div className="col-md-m3">
                  <img className="img-responsive center-block" style={{height:"150px"}} src="img/estafa_laboral_en.png" alt="alert" />
                </div>
              </div>
              <div id="extortion" className="row" style={{marginTop:45}}>
                <div className="col-md-9">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    6.- Extortion
                  </p>
                  <p>
                    Threats to life, arrest or other demands by scammers to unlawfully 
                    obtain money, property or services from a victim through coercion 
                    that they supposedly owe and threatens if they do not cooperate.
                  </p>
                  <p>They make calls where they seek to trick you, threaten you to the 
                    point of scaring you to take your money.</p>
                  <p>
                    The parent extortion phone scam starts with someone who sends you a 
                    photo of your own child by textmessage—the photo might have been 
                    taken from the internet, for example, from your public social media 
                    account. Sometimes these scammers also send scary photos, such as images 
                    of quartered bodies. In either case, the messages come along with a 
                    scammer's threat that says he knows where you live and that he'll kill 
                    your family if you don't pay him. If you get a call like this, before 
                    you do anything else, report it to your local police department immediately.
                  </p>
                  <p>Associated with: <br/><a href="#advancedFee">Advanced Fee / Prepayment scam</a>, 
                    <a href="#relationship">Relationship scam</a>, 
                    <a href="#immigrationScam">Immigration scam</a>, 
                    <a href="#taxScam">Tax scam</a>, 
                    <a href="#emergency">Emergency scam</a>, 
                    <a href="#antivirus">Anti-Virus scam</a>, 
                    <a href="#phishing"> Phishing</a>
                  </p>
                  <p>
                      Article Relate:<br/><a target="_blank" href="https://www.consumidor.ftc.gov/blog/2020/10/estafas-telefonicas-amenazantes-contra-padres-e-inmigrantes">
                      https://www.consumidor.ftc.gov/blog/2020/10/estafas-telefonicas-amenazantes-contra-padres-e-inmigrantes
                    </a>
                  </p>
                </div>
                <div className="col-md-m3">
                  <img className="img-responsive center-block" style={{height:"150px"}} src="img/extorcion_en.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="fakeCheck" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    7.- Fake Check scam
                  </p>
                  <p>
                    Victims are often sent a check as a part of a scam and told to deposit 
                    the check and use the funds for employment expenses, internet purchases, 
                    mystery shopping, etc. The check is fake (counterfeit), and the victim 
                    is left responsible for any funds used from the check. Remember, funds 
                    from a check deposited into an account should not be used until the 
                    check officially clears which can take weeks.
                  </p>
                  <p>Associated with: <br/> 
                    <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, Mystery Shopping scam, 
                    <a href="#employment">Employment scam</a>, 
                    <a href="#overpaymentScam">Overpayment scam</a>, 
                    <a href="#internetPurchase">Internet Purchase scam</a>, 
                    <a href="#loteryScam">Lottery / Prize scam</a>,
                    <a href="#rentalScam">Rental Property scam</a>
                  </p>
                </div>
                <div id="grandparentScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    8.- Grandparent scam
                  </p>
                  <p>
                    This scam is a variation on the Emergency scam. The victim is contacted 
                    by an individual pretending to be a grandchild in distress, or a person 
                    of authority such as a medical professional, law enforcement officer, 
                    or attorney.
                  </p>
                  <p>
                    The fraudster describes an urgent situation or emergency (bail, medical 
                    expenses, emergency travel funds) involving the grandchild that requires 
                    a money transfer to be sent immediately.
                  </p>
                  <p>
                    No emergency has occurred, and the victim who sent money to help their 
                    grandchild has lost their money.
                  </p>
                  <p>Associated with: <br/> 
                    <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, 
                    <a href="#emergency">Emergency scam</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="immigrationScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    9.- Immigration scam.
                  </p>
                  <p>
                    Phone scam against immigrants, begins <a target="_blank"
                    href="https://www.consumer.ftc.gov/media/video-0117-family-emergency-imposter-scams">
                      <strong>as a call from an imposter</strong>
                    </a> impersonating someone from the U.S. Immigration and Customs Enforcement 
                    (ICE) Service. Often, these scammers say they're revoking your immigration 
                    status and that the police are on their way to arrest or deport you — 
                    unless you pay them right away.
                  </p>
                  <p>Associated with: <br/> 
                    <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, 
                    <a href="#overpaymentScam">Overpayment scam</a>, <a href="#emergency">Emergency scam</a>
                  </p>
                </div>
                <div id="internetPurchase" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    10.- Internet Purchase scam
                  </p>
                  <p>
                    Victims could be the buyer or a seller of items (e.g. pets, cars) or 
                    services advertised online through Craigslist, eBay, Alibaba, Gumtree, 
                    carsales.com, etc. Scammers pretending to be legitimate online sellers, 
                    either with a fake website or a fake ad on a genuine site advertising 
                    an item at a low price. They ask you to pay using a money order, 
                    pre-loaded money card or money transfer, after the money is sent, the 
                    victim never receives the merchandise or service. Scammers also pretend 
                    to be legitimate buyers by sending more than the selling price, and 
                    asks the seller to wire the difference back to them via a money transfer
                  </p>
                  <p>Associated with: <br/>
                    <a href="#overpaymentScam">Overpayment scam</a>, <a href="rentalScam">Rental Property scam</a>, 
                    <a href="#fakeCheck">Fake Check scam</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="loteryScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    11.- Lottery / Prize scam
                  </p>
                  <p>
                    Victim is told that they have won a lottery, prize or 
                    sweepstakes and that money must be sent to cover the taxes 
                    or fees on the winnings. The victim may receive a check 
                    for part of the winnings and once the check is deposited 
                    and money is sent, the check bounces.
                  </p>
                  <p>Associated with: <br/>
                    <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, <a href="#fakeCheck">Fake Check scam</a>
                  </p>
                </div>
                <div id="moneyFlippingScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    12.- Money-Flipping scam
                  </p>
                  <p>
                    Social media is being used to lure new victims into an old 
                    get-rich-quick scam where users are advertising ways to turn 
                    $100 into $1,000 by “flipping money”. The pitch suggests 
                    investors can take advantage of quirks in the monetary system 
                    to leverage additional cash and turn a few hundred dollars 
                    into thousands. Once con artists have access to the cash, 
                    they often block the victim from contacting them via social 
                    media or phone number.
                  </p>
                  <p>Associated with: <br/> 
                    <a href="#socialNetworkScam">Social Networking scam</a>, <a href="#advancedFee">Advanced Fee / Prepayment scam</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="military" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    13.- Military
                  </p>
                  <p>
                    Military service members are an appealing target for scammers for 
                    several reasons. They are abusing the wide-spread admiration for 
                    the military and posing as service men and women in order to trick 
                    people into sending them money.
                  </p>
                  <p>Associated with: <br/> 
                    <a href="#relationship">Relationship scam</a>, <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, 
                    <a href="#emergency">Emergency scam</a>, <a href="#charity">Charity scam</a>, 
                    <a href="#employment">Employment scam</a>
                  </p>
                </div>
                <div id="overpaymentScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    14.- Overpayment scam
                  </p>
                  <p>
                    The fraudster contacts the victim through an employment website, 
                    or the victim responds to an ad about an employment opportunity 
                    to evaluate a money transfer service. The fraudster often sends 
                    the victim a check to deposit and instructs the victim to send 
                    a money transfer, keeping a portion of the check for their pay. 
                    The victim sends the money, the fraudster picks it up, and when 
                    the check bounces the victim is left responsible for the full 
                    amount.
                  </p>
                  <p>Associated with: <br/> 
                    <a href="#internetPurchase">Internet Purchase scam</a>, <a href="#fakeCheck">Fake Check scam</a>, 
                    <a href="#advancedFee">Advanced Fee / Prepayment scam</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="phishing" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    15.- Phishing
                  </p>
                  <p>
                    Communication impersonating a trustworthy entity, such as a bank 
                    or mortgage company, intended to mislead the victim into providing 
                    personal information or passwords. A Phish is a fraudulent attempt, 
                    usually made through email (although can also be made via phone or 
                    text), to steal your personal information or propagate malicious 
                    code or software onto your computer.
                  </p>
                  <p>Associated with: <br/>
                    <a href="#relationship">Relationship scam</a>, <a href="#extortion">Extortion</a>, 
                    <a href="#emergency">Emergency scam</a>, <a href="#socialNetworkScam">Social Networking scam</a>, 
                    <a href="#sms">SMS/Smishing</a>
                  </p>
                </div>
                <div id="relationship" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    16.- Relationship scam
                  </p>
                  <p>
                    Victim is led to believe that they have a personal relationship 
                    with someone they met online often by social media, in an online 
                    forum or on a dating website. The victim is often emotionally 
                    invested, often referring to the recipient as a fiancée.
                  </p>
                  <p>Associated with: <br/> 
                    <a href="#socialNetworkScam">Social Networking scam</a>, <a href="#military">Military</a>, 
                    <a href="#emergency">Emergency scam</a>, <a href="#extortion">Extortion</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="rentalScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    17.- Rental Property scam
                  </p>
                  <p>
                    Victim sends money for deposit on a rental property and 
                    never receives access to the rental property or the victim 
                    may also be the property owner who is sent a check from 
                    the renter and asked to send a portion of the check back 
                    using a money transfer and the check bounces.
                  </p>
                  <p>Associated with: <br/>
                    <a href="#internetPurchase">Internet Purchase scam</a>, <a href="#fakeCheck">Fake Check scam</a>, 
                    <a href="#overpaymentScam">Overpayment scam</a>
                  </p>
                </div>
                <div id="socialNetworkScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    18.- Social Networking scam
                  </p>
                  <p>
                    If a cybercriminal gains access to your social media accounts, 
                    they also gain access to your close friends and family. 
                    Criminals and con artists can take advantage of how much 
                    personal information people share online, and then use this 
                    information to make skillful and highly targeted pitches to 
                    their friends and family, often involving requests for money.
                  </p>
                  <p>Associated with: <br/>
                    <a href="#phishing">Phishing</a>, <a href="#emergency">Emergency scam</a>, 
                    <a href="#grandparentScam">Grandparent scam</a>, <a href="#military">Military</a>, 
                    <a href="#sms">SMS/Smishing</a>, <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, 
                    <a href="#relationship">Relationship scam</a>, Identity Theft
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="sms" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    19.- SMS/Smishing
                  </p>
                  <p>
                    Beware of texts that spark urgency, asking you to click on 
                    a link, taking you to a compromised site, or get you to 
                    unwittingly divulge some personal information that could 
                    be used against you.
                  </p>
                  <p>Associated with: <br/>
                    Identity Theft, <a href="#phishing">Phishing</a>, <a href="#antivirus">Anti-Virus scam</a>, 
                    <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, <a href="#loteryScam">Lottery / Prize scam</a>
                  </p>
                </div>
                <div id="taxScam" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    20.- Tax scam
                  </p>
                  <p>
                    Victim is contacted by someone claiming to be from a 
                    governmental agency saying that money is owed for taxes, 
                    and it must be paid immediately to avoid arrest, deportation 
                    or suspension of driver’s license/passport. The victim is 
                    instructed to send a money transfer or purchase a pre-loaded 
                    debit card to pay the taxes. Government agencies will never 
                    demand immediate payment or call about taxes without first 
                    having mailed a bill.
                  </p>
                  <p>Associated with: <br/>
                    <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, <a href="#overpaymentScam">Overpayment scam</a>
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:45}}>
                <div id="telemarketing" className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    21.- Telemarketing
                  </p>
                  <p>
                    Telemarketing broadly covers almost any commercial transaction 
                    that involves the use of a telephone to place or receive calls 
                    between a consumer and a telemarketer or seller for the 
                    transferring of funds, such as cash-to-cash money transfers or 
                    funds loaded onto a prepaid card, as payment for goods or 
                    services offered or sold through telemarketing, often 
                    relating to a promotion for a “free” or heavily discounted 
                    vacation, prize or sweepstakes scams, or the sale of “bargain” 
                    magazines.
                  </p>
                  <p>Associated with: <br/>
                    <a href="#charity">Charity scam</a>, <a href="#advancedFee">Advanced Fee / Prepayment scam</a>, 
                    <a href="#rentalScam">Rental Property scam</a>, <a href="#loteryScam">Lottery / Prize scam</a>, 
                    <a href="#internetPurchase">Internet Purchase scam</a>, Identity Theft
                  </p>
                </div>
              </div>
              
            </div>
          }
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./js/fraudAwareContent/fraudTypes.js